module.exports = __webpack_public_path__ + "static/m_hero_art-d171c989df9455ff05dae5aaba786dab.png";